<template>
  <header class="navigation" id="nav-bar" :class="isMobile ? 'navigation-phone-none' : ''">
    <template v-if="isMobile">
      <div  :class="routeName ? 'navigation-phone-on' : 'navigation-phone-none mb-0'" style="border-bottom: 1px solid #f8f8f8">
        <div class="offcanvas pt-0">
          <div class="offcanvas-inner">
            <a class="offcanvas-toggle"
               href="javascript:void(0);"
               data-toggle="offcanvas"
               @click="offCanvasOpen()"
            >
              <i class="fa fa-bars"></i>
            </a>
          </div>
        </div>
        <nav class="site-menu" style="display: block !important;max-height: 50px">
          <ul style="margin: auto">
            <!--<li v-bind:style="{ 'background-color': color }">-->
            <li>
              <router-link class="site-logo pt-5 pb-5" :to="{ name: 'home' }">
                <img :src="logo" :alt="siteName" style="max-height: 28px"/>
              </router-link>
            </li>
          </ul>
        </nav>

        <tool-bar />
        <template v-if="isMobile && routeName">
          <SearchBar class="search-phone"/>
        </template>
      </div>
    </template>
    <template v-if="!isMobile">
    <div class="container nav-post" >
        <div class="site-branding col-4">
          <div class="custom">
            <ul>
              <li class="index" :class="{ active: navActive === 'index' }">
                <router-link :to="{ name: 'home' }">{{ $t('nav.home') }}</router-link>
              </li>
              <li class="products" :class="{ active: navActive === 'products' }">
                <router-link :to="{ name: 'shop-index' }">{{ $t('nav.straight') }}</router-link>
              </li>
              <li class="proxy" :class="{ active: navActive === 'proxy' }">
                <router-link :to="{ name: 'proxy-request' }">{{ $t('nav.proxy_buy') }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Main Navigation-->

        <nav class="site-menu">
          <ul>
            <!--<li v-bind:style="{ 'background-color': color }">-->
            <li>
              <router-link class="site-logo" to="/">
                <img v-if="isWorldhub" src="../../assets/logo/worldhub/04.png" alt="WorldHub" />
                <img v-else src="../../assets/logo/logo.png" alt="Okubuy" />
              </router-link>
            </li>
          </ul>
        </nav>
        <tool-bar />

    </div>
    <div class="second-nav" :class="stuck === false ? 'navbar-stuck' : 'navbar-stuck-fix'">
      <div style="position: relative; width: 100%">
        <div class="nav-index" v-if="navActive === 'index'">
          <ul  class="nav-two container pt-15 pb-15" style="padding-right: 10%">
            <li><router-link :to="{ name: 'products:new' }">{{ $t('nav.new_product') }}</router-link></li>
            <li><router-link :to="{ name: 'products:hot-sales' }">{{ $t('nav.hot_sales_product') }}</router-link></li>
            <li><router-link :to="{ name: 'products:sale' }">{{ $t('nav.off_price_product')}}</router-link></li>
            <li class="brands-nav">
              <a href="javascript:;">{{ $t('product.brand')}}</a>
              <div class="all-brands">
                <div class="brands-letter">
                  <a href="javascript:;"
                     v-for="(brands, letter) in brandsByFistLatter"
                     :key="letter"
                     @click="tapBrands(letter)"
                     :class=" !brands.length ? 'brands-disable' : ' ' "
                  >
                    {{ letter }}
                  </a>
                </div>
                <dl class="row" :id="letter" v-for="(brands, letter) in brandsByFistLatter" :key="letter" v-if="brands.length">
                  <hr />
                  <dt class="col-1 offset-1"><h1>{{ letter }}</h1></dt>
                  <dd class="col-10">
                    <dl class="row brands-dl pt-1">
                      <dd class="" v-for="brand in brands" :key="brand.id">
                        <router-link :to="{ name: 'brand', params: { id: brand.id, name: brand.name.replace(/\s+/, '-') } }">
                          {{ brand.name }}
                        </router-link>
                      </dd>
                    </dl>
                  </dd>
                </dl>
              </div>
            </li>
            <li class="brands-nav">
              <a href="javascript:;">{{ $t('product.source')}}</a>
              <div class="all-brands source">
                <div class="brands-letter pt-0">
                </div>
                <dl class="row mx-0 pl-10 pr-10">
                  <dd class="col-2" v-for="sources in source" :key="sources.id">
                    <dl class="row brands-dl pt-1">
                      <dd>
                        <router-link class="source-img" :to="{ name: 'source', params: { id: sources.id } }">
                          <img :src="sources.flag" alt=""> {{ sources.language_name }}
                        </router-link>
                      </dd>
                    </dl>
                  </dd>
                </dl>
              </div>
            </li>
          </ul>
        </div>

        <div class="nav-products" :class="language === 'en' || 'fr' ? 'en' : '' " v-if="navActive === 'products'">
          <ul  class="nav-two container" style="padding-right: 10%">
            <li v-for="category in categories.slice(0,9)" :key="category.id" class="classify-first" v-if="category.visibility && category.product_count">
              <template>
                <router-link class="classify-first-router" :to="{ name: 'category', params: {id: category.id} }">
                  {{ category.name }}
                </router-link>
                <div class="category-nav pt-10 pl-0 pr-0 container" v-if="category.nodes">
                  <ul v-for="secondNode in category.nodes.slice(0,7)" :key="secondNode.id"  v-if="secondNode.visibility && secondNode.product_count">
                    <li>
                      <router-link :to="{ name: 'category', params: { id: secondNode.id }}" style="color: #374250">
                        {{ secondNode.name }}
                      </router-link>
                    </li>
                    <template v-if="secondNode.nodes">
                      <li v-for="thirdNode in secondNode.nodes.slice(0,15)" :key="thirdNode.id"  v-if="thirdNode.visibility && thirdNode.product_count">
                        <router-link :to="{ name: 'category', params: { id: thirdNode.id }}">
                          {{ thirdNode.name }}
                        </router-link>
                      </li>
                    </template>
                  </ul>
                  <p class="more-category" style="display: block;width: 100%">
                    <router-link :to="{ name: 'category', params: { id: category.id }}">{{ $t('nav.more_classify')}}</router-link>
                  </p>
                </div>
              </template>
            </li>
          </ul>
        </div>

        <div class="nav-proxy" v-if="navActive === 'proxy'">
          <ul class="nav-two container pt-15 pb-15" style="padding-right: 10%">
            <!--<li>-->
              <!--&lt;!&ndash;<router-link :to="{ name: 'rakuten' }" class="d-block img-thumbnail text-center navi-link">&ndash;&gt;-->
              <!--&lt;!&ndash;<img alt="Rakuten" src="../../assets/shops/rakuten.svg" />&ndash;&gt;-->
              <!--&lt;!&ndash;-->
              <!--<router-link :to="{ name: 'rakuten' }">-->
                <!--Rakuten-->
              <!--</router-link>-->
              <!--&ndash;&gt;-->
              <!--<a href="javascript:void(0);" @click="commingSoon()">Rakuten</a>-->
            <!--</li>-->
            <!--<li>-->
              <!--&lt;!&ndash;<router-link :to="{ name: 'yahoo_jp' }" class="d-block img-thumbnail text-center navi-link">&ndash;&gt;-->
              <!--&lt;!&ndash;<img alt="Featured Categories" src="../../assets/shops/yahoo-jp.png" />&ndash;&gt;-->
              <!--&lt;!&ndash;-->
              <!--<router-link :to="{ name: 'yahoo_jp' }">-->
                <!--YAHOO!-->
              <!--</router-link>-->
              <!--&ndash;&gt;-->
              <!--<a href="javascript:void(0);" @click="commingSoon()">YAHOO!</a>-->
            <!--</li>-->
            <li>
              <!--<router-link :to="{ name: 'proxy-request' }" class="align-middle">-->
              <router-link :to="{ name: 'proxy-request' }">
                {{ $t('nav.proxy_request') }}
                <!--<h6 class="mt-3"></h6>-->
                <!--<br/>-->
                <!--<h6 class="mt-3">proxy-request</h6>-->
              </router-link>
            </li>
          </ul>
        </div>

        <div class="nav-search-bar-container" :class="{ visible: searchToolOpened }">
          <div class="container">
            <search-bar />
            <div class="nav-search-bar-close-btn">
              <i class="fa fa-times-circle-o" aria-hidden="true" @click="searchToolClose()"></i>
            </div>
          </div>
        </div>

        <div class="conceal" v-show="stuck && !searchToolOpened">
          <div class="search conceal-icon">
            <a href="javascript:" @click.prevent="searchToolOpen()">
              <i class="fa fa-search" aria-hidden="true" style="font-size: 22px;padding-top: 1px"></i>
            </a>
          </div>
          <!--<search :style="{background: styleColor.background}" :stuck="stuck"/>-->

          <div class="account conceal-icon" style="padding-top: 1px">
            <a href="javascript:;">
              <i class="fa fa-user-o" aria-hidden="true" style="font-weight: bold; font-size: 23px"></i>
            </a>
            <ul class="toolbar-dropdown">
              <template v-if=" isLogined && user">
                <!--<li class="sub-menu-user">-->
                <!--<div class="user-ava">-->
                <!--<img :src="user.avatar_url" alt="Daniel Adams">-->
                <!--</div>-->
                <!--<div class="user-info">-->
                <!--<h6 class="user-name">{{ user.actual_name || user.name }}</h6>-->
                <!--</div>-->
                <!--</li>-->
                <li>
                  <router-link :to="{ name: 'dashboard' }">
                    <i class="fa fa-home"></i>{{ $t('user.user_center') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'orders' }">
                    <i class="fa fa-calendar-check-o"></i>{{ $t('user.my_orders') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'shipping-address' }">
                    <i class="fa fa-map-o"></i>{{ $t('user.shipping_address') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'wishlist' }">
                    <i class="fa fa-heart-o"></i>{{ $t('user.wish_list') }}

                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'history' }">
                    <i class="fa fa-history"></i>{{ $t('user.product_view_history') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'information'}">
                    <i class="fa fa-user-o"></i>
                    {{ $t('user.information') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'proxy-request-list'}">
                    <i class="fa fa-shopping-bag"></i>
                    {{ $t('user.proxy_list') }}
                  </router-link>
                </li>
                <li class="sub-menu-separator">
                  <a href="/logout" @click.prevent="logout()">
                    <i class="fa fa-sign-out"></i>
                    {{ $t('user.logout') }}
                  </a>
                </li>
              </template>
              <template v-else>
                <li>
                  <router-link :to="{ name: 'login' }">
                    <!--<i class="fa fa-sign-in"></i>-->
                    {{ $t('app.login') }}
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'register' }">
                    {{ $t('app.register') }}
                  </router-link>
                </li>
              </template>
            </ul>
          </div>
          <div class="cart conceal-icon" :class="{ open: showCart }">
            <a href="javascript:" @click="toggleCartSidebar()" style="padding-top: 2px">
              <!--<el-badge :value="getCartCount">-->
              <i class="fa fa-shopping-cart" style="font-size: 25px"></i>
              <!--</el-badge>-->
            </a>
          </div>
        </div>
      </div>


    </div>
  </template>
  </header>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import SearchBar from './SearchBar.vue';
  import ToolBar from './ToolBar.vue';

  const isWorldhub = window.location.hostname === 'worldhub.market';

  export default {
    name: 'NavBar',
    data() {
      return {
        stuck: false,
        key: 1,
        brandsRank: {},
        styleColor: {
          background: '#79c7de',
          color: '#fff',
        },
        isWorldhub,
      };
    },
    mounted() {
      window.addEventListener('scroll', () => {
        this.stuck = window.pageYOffset > 155;
      });
      this.$store.dispatch('fetchProductBrands');
      this.$store.dispatch('fetchSource');
    },
    watch: {
      stuck() {
        if (this.stuck === false) {
          this.searchToolClose();
        }
      },
    },
    computed: {
      ...mapState({
        brands: state => state.product.brands,
        categories: state => state.product.categories,
        user: state => state.user.identity,
        showCart: state => state.cart.showCart,
        searchToolOpened: state => state.app.searchToolOpened,
        source: state => state.product.source,
        language: state => state.app.language,
      }),
      ...mapGetters([
        'isLogined',
        'isMobile',
        'getCartCount',
        'brandsByFistLatter',
      ]),
      routeName() {
        switch (this.$route.name) {
          case 'category':
          case 'brand':
          case 'home':
          case 'shop-index':
            return true;
          default:
            return false;
        }
      },
      navActive() {
        switch (this.$route.name) {
          case 'product':
          case 'product-has-specification':
          case 'category':
          case 'brand':
          case 'search':
          case 'shop-index':
            return 'products';
          case 'amazon':
          case 'amazon-category':
          case 'amazon-product-detail':
          case 'rakuten':
          case 'rakuten-category':
          case 'rakuten-search':
          case 'rakuten-product-detail':
          case 'yahoo_jp':
          case 'yahoo_jp-category':
          case 'yahoo_jp-search':
          case 'yahoo_jp-product-detail':
          case 'proxy-request':
            return 'proxy';
          case 'home':
          default:
            return 'index';
        }
      },
    },
    methods: {
      ...mapActions([
        'offCanvasOpen',
        'searchToolOpen',
        'searchToolClose',
      ]),
      tapBrands(tap) {
        document.querySelector(`#${tap}`).scrollIntoView(true);
      },
      logout() {
        this.$store.dispatch('logout').then(() => {
          if (this.$route.meta.needAuthenticate) {
            this.$router.push({ name: 'home' });
          }
        });
      },
      toggleCartSidebar() {
        this.$store.dispatch('setShowCart', !this.showCart);
      },
      commingSoon() {
        this.$alert('Coming soon!!', '');
      },
    },
    components: {
      SearchBar,
      ToolBar,
    },
  };
</script>

<style lang="scss">

  @import "../../styles/helpers/variables";
  @import "../../styles/helpers/placeholders";

  $index-bg: #79c7de;
  $products-bg: #e8c976;
  $proxy-bg: #f17374;
  /*html, body {height:100%;overflow:auto;margin: 0;}*/
  .brands-disable {
    color: #b2b2b2 !important;
    background-color: rgba(195, 195, 195, .4);
    &:hover {
      cursor: not-allowed;
    }
  }

  .brands-disable1 {
    color: red;
  }

  .navbar-stuck-fix {
    position: fixed;
    top: 0;
    z-index: 9010;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }

  .navbar-stuck {
    position: absolute;
    top: 120px;
    /*z-index: 9010;*/
  }

  #nav-bar {
    font-size: 16px;
    .nav-post {
      position: relative;
      top: 0;
      left: 0;
      min-height: 120px;

      .site-branding {
        display: flex;
        align-items: flex-end;

        .custom {
          ul {
            list-style: none;
            display: flex;
            height: 50%;
            padding-left: 0px;
            margin-bottom: 0px;
            /*align-items: flex-end;*/
            li {
              height: 100%;

              &.index.active {
                background-color: $index-bg;
              }

              &.products.active {
                background-color: $products-bg;
              }

              &.proxy.active {
                background: $proxy-bg;
              }

              &.active a {
                color: white;
              }

              a {
                display: block;
                width: 100%;
                height: 100%;
                padding: 5px 20px 3px;
                color: #606975;
                font-weight: bold;
                text-decoration: none;
              }
            }
          }
        }
      }
    }
    .en {
      .classify-first {
        max-width: 125px;
        line-height: .9;
        padding: 5px 20px !important;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        .classify-first-router {
          /*font-size: 14px;*/
        }
        div {
          ul {
            li {
              padding: 8px 0 !important;
              line-height: 1;
              font-size: 13px;
            }
            li:nth-child(1) {
              min-height: 43px;
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
    .source {
      .source-img {
        img {
          height: 25px;
          width: auto;
        }
      }
      .source-img:hover {
        border: none !important;
      }
    }
    .second-nav {
      /*position: absolute;*/
      display: flex;
      width: 100%;
      -webkit-transform: translateZ(0) !important;
      .nav-two {
        list-style: none;
        position: relative;
        margin: auto;
        /*width: 40%;*/
        padding: 10px 0;
        display: flex;
        flex-direction: row;
        /*justify-content: space-between;*/

        li {
          /*width: 15%;*/
          padding: 0 18px;
          line-height: .9;
          height: 100%;
          .category-nav {
            position: absolute;
            left: 0;
            top: 34px;
            display: none;
            ul {
              background-color: #f9f9f9;
              list-style: none;
              padding: 0 15px;
              flex: 1;
              li {
                height: auto;
                padding: 2px 5px;
                h6 {
                  padding: 10px 0 5px;
                  margin: 0;
                }
                &:first-child {
                  border-bottom: 1px solid $gray;
                }
              }
            }
            .more-category {
              background-color: #f9f9f9;
              /*height: 30px;*/
              padding: 15px 0;
              text-align: center;
              a {
                color: #000;
                font-weight: inherit;
                font-size: 13px;
                &:hover {
                  color: $brand-primary;
                  border: none;
                }
              }
            }
            a {
              color: $gray;
              &:hover {
                color: $brand-primary;
                border: none;
              }
            }
          }
          &:hover .category-nav {
            display: flex;
            flex-wrap: wrap;
            transition: all .1s;
          }
          a {
            color: #fff;
            font-weight: bold;
            text-decoration: none;
            white-space: nowrap;
            overflow: hidden;
          }
          a:hover {
            border-bottom: 2px solid #fff;
          }
        }
        .brands-nav {
          position: relative;
          .all-brands {
            z-index: -1;
            opacity: 0;
            height: 0 !important;
            transition: all .5s;
            position: absolute;
            left: -170%;
            background-color: #f9f9f9;
            border: {
              left: 1px solid $gray-light;
              right: 1px solid $gray-light;
              bottom: 1px solid $gray-light;
            }
          ;
            top: 22px;
            height: 25rem;
            overflow-y: scroll;
            .brands-letter {
              display: flex;
              justify-content: space-around;
              width: 50rem;
              padding: 1rem 8rem;
              a {
                width: 15px;
                height: 15px;
                font-size: .75em;
                font-weight: inherit;
                display: flex;
                align-items: center;
                justify-content: center;
                color: $gray-dark;
                border: 1px solid $gray-dark;
                &:last-child {
                  font-size: 1em;
                  padding-bottom: 1px;
                }
                &:hover {
                  border-bottom: 1px solid $gray-dark;
                }
              }
            }
            dl {
              margin-bottom: 0 !important;
              hr {
                width: 90%;
                left: 5%;
                position: absolute;
              }
              dt {
                color: $gray-dark;
              }
              dd {
                margin-top: 0;
                color: $gray-dark;
                .brands-dl {
                  dd {
                    padding: 8px 15px;
                    a {
                      color: $gray-dark;
                      font-weight: inherit;
                      font-size: .9em;
                      &:hover {
                        color: $brand-primary;
                        border-bottom: 1px solid $brand-primary;
                      }
                    }
                  }
                }
              }
            }
          }
          &:hover .all-brands {
            opacity: 1;
            height: 25rem !important;
            transition: all .5s;
          }
        }
      }
      .nav-index {
        background-color: $index-bg;
      }
      .nav-products {
        background-color: $products-bg;
      }
      .nav-proxy {
        background-color: $proxy-bg;
      }
      .conceal {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        top: 0;
        right: 20%;
        width: 6%;
        height: 100%;
        max-width: 150px;
        .conceal-icon {
          /*padding: 0 5px;*/
          margin: 0 10px;
          width: 28px;
          height: 100%;
          line-height: 44px;
          .toolbar-dropdown {
            /*opacity: 0;*/
            display: none;
            max-width: 160px;
            flex-direction: column;
            left: -20px;
            margin-top: 0px !important;
            li {
              padding: 0px;
              a {
                width: 100%;
                color: #606975;
              }
              a:hover {
                border: none;
              }
            }
            li:hover a {
              color: #0EA9EF;
            }
          }
          a {
            width: 28px;
            height: 100%;
            /*border: 1px solid #fff;*/
            border-radius: 50%;
            display: block;
            color: white;
            text-align: center;
            i {
              font-size: 18px;
            }
          }
          a:hover {
            /*border: 1px solid #0da9ef;*/
            color: #0da9ef;
          }
        }
        .account:hover,
        .cart:hover {
          > .toolbar-dropdown {
            /*opacity: 1;*/
            display: flex;
            animation: submenu-show .3s cubic-bezier(.68, -.55, .265, 1.55);
          }
        }
      }
    }
  }
  .navigation-phone-on{
    min-height: $navbar-min-height + 21 !important;
  }
  .navigation-phone-none{
    min-height: $navbar-min-height - 34 !important;
  }
  .navigation {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    min-height: $navbar-min-height + 80;
    /*border-bottom: 1px solid $border-color;*/
    background-color: $white-color;
    z-index: 9000;
  }

  // Site Logo + Off-Canvas Toggle
  .site-branding {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    max-height: 120px;
    z-index: 5;
    .inner {
      display: table;
      height: 100%;
      min-height: 100%;
    }
  }

  .offcanvas {
    position: absolute;
    top: 0;
    left: 0;
    height: 3.7rem;
    z-index: 5;
    padding: {
      top: 10px;
      /*bottom: 10px;*/
    };
    .offcanvas-inner {
      display: table;
      height: 100%;
      min-height: 100%;
    }
  }
  .search-phone {
    position: absolute;
    top: 3.5rem;
  }
  .site-logo,
  .offcanvas-toggle {
    display: table-cell;
    vertical-align: middle;
  }

  // Site logo
  .site-logo {
    width: ($logo-width + 30);
    /*padding: 10px 0 9px 30px;*/
    text-decoration: none;
    > img {
      display: block;
      width: 100%;
    }
    &.logo-stuck {
      display: none;
    }
  }

  .navbar-ghost.navbar-stuck {
    .site-logo {
      display: none;
    }
    .site-logo.logo-stuck {
      display: table-cell;
    }
  }

  // Categories Toggle
  .offcanvas-toggle {
    width: 74px;
    transition: color .3s;
    /*border-right: 1px solid $border-color;*/
    color: $navbar-tools-color;
    font-size: $offcanvas-toggle-icon-size;
    line-height: 1;
    cursor: pointer;
    text: {
      align: center;
      decoration: none;
    }
    /*&::before {*/
    /*display: inline-block;*/
    /*font-family: "FontAwesome";*/
    /*content: "\f0c9";;*/
    /*}*/
    &:hover {
      color: $nav-link-hover-color;
    }
    &.menu-toggle {
      display: none;
    }
  }

  // Main Navigation
  .site-menu {
    position: absolute;
    top: 5px;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 120px;
    text-align: center;
    z-index: 1;
    ul {
      /*margin: 0 auto;*/
      padding: 0;
      list-style: none;
      > li {
        vertical-align: inherit !important;
        > a {
          padding: 10px 0;
          transition: color .3s;
          color: $nav-link-color;
          font: {
            size: $nav-link-font-size;
            weight: $nav-link-font-weight;
          }
          text-decoration: none;
          > img {
            max-height: 54px;
            width: auto;
            height: 100%;
            margin: auto;
          }
        }
        &:hover > a {
          color: $nav-link-hover-color;
        }
        &.active > a {
          color: $nav-link-active-color;
        }
        .proxy-request {
          height: 140px;
          padding: 5px;
          vertical-align: middle;
        }
      }
    }
    > ul {
      display: table;
      height: 100%;
      min-height: 100%;
      > li {
        display: table-cell;
        position: relative;
        vertical-align: middle;
        > a {
          display: table;
          height: 100%;
          max-height: 74px;
          /*border-top: 1px solid transparent;*/
          letter-spacing: .05em;
          text-transform: uppercase;
          > span {
            display: table-cell;
            vertical-align: middle;
          }
        }
        &.active > a {
          border-top-color: $nav-link-active-color;
        }
      }
    }
  }

  // Sub Menu
  .sub-menu {
    @extend %sub-menu;
  }

  .site-menu ul > li:hover {
    > .sub-menu {
      display: block;
      animation: submenu-show .3s cubic-bezier(.68, -.55, .265, 1.55);
    }
    > .mega-menu {
      display: table;
      animation: megamenu-show .45s cubic-bezier(.68, -.55, .265, 1.55);
      .sub-menu {
        animation: none;
      }
    }
  }

  // Mega Menu
  .mega-menu {
    @extend %mega-menu;
    > li {
      width: 25%;
      vertical-align: middle;
      height: 130px;
      line-height: 130px;
      img {
        width: auto;
        height: 100%;
      }
    }
  }

  .site-menu > ul > li.has-megamenu {
    position: static;
  }

  .nav-search-bar-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 10;
    display: block;
    opacity: 0;
    visibility: hidden;
    transition: .3s;
    padding-top: 1px;
    box-shadow: 0 3px 25px 0 rgba(47,56,68,.22);
    &.visible {
      visibility: visible;
      opacity: 1;
    }
    .search-bar {
      width: 95%;
      .el-input-group__append {
        width: 5% !important;
      }
    }

    .nav-search-bar-close-btn {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 5%;
      padding-left: 1rem;
      i {
        color: white;
        font-size: 1.2rem;
        cursor: pointer;
      }
    }
  }

  // Navbar (Menu) Collapse
  @media (max-width: $nav-collapse) {
    .navbar {
      min-height: 78px;
    }
    .toolbar {
      right: 15px;
    }
    .offcanvas-toggle.menu-toggle {
      display: table-cell;
    }
    .site-menu,
    .offcanvas-toggle.cats-toggle
      // ,.toolbar .account,
      /*.toolbar-dropdown */
    {
      display: none !important;
    }
    .topbar {
      padding: {
        right: 15px;
        left: 15px;
      }
    }
  }
  @media (max-width: 1170px) {
    .custom ul li a {
      padding: 4px 14px 3px;
    }
    .classify-first {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  @media (max-width: $screen-sm) {
    .offcanvas-toggle {
      width: 56px;
    }
    .site-logo {
      width: ($logo-width + 16);
      /*padding-left: 16px;*/
    }
  }

  @media (max-width: 320px) {
    .offcanvas-toggle {
      width: 42px;
    }
    .site-logo {
      width: 110px;
      /*padding-left: 8px;*/
    }
  }
</style>
